export enum ConsentGeneralEvent {
  AcceptAll = 'accept-all',
  ManageOptions = 'manageOptions'
}
